"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { SITE_META_PIXEL_ID, trackMetaPixelEvent } from "@/lib/meta-pixel";

export default function MetaPixelPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const searchParamsString = searchParams.toString();

  useEffect(() => {
    // App Router navigations are client-side, so page views need to be sent on route changes.
    trackMetaPixelEvent(SITE_META_PIXEL_ID, "PageView");
  }, [pathname, searchParamsString]);

  return null;
}
